// extracted by mini-css-extract-plugin
export var formContainer = "_hz-0";
export var message = "_hz-1";